.container {
  margin-top: 16px;
  padding-left: var(--page-margin);
  padding-right: var(--page-margin);

  @media all and (--reefer-media-tablet-min) {
    margin-top: 24px;
    padding-left: var(--page-margin-desktop);
    padding-right: var(--page-margin-desktop);
  }
}
